export const userNameLocalStorageKey = 'login.userName';
